export const CHART_SERIES_PALETTE = [
  '#4C9AE8',
  '#3DCC7A',
  '#E8A317',
  '#E85D4C',
  '#B692F6',
  '#2DD4BF',
  '#F79009',
  '#EE46BC',
  '#A3E635',
  '#38BDF8',
  '#FB7185',
  '#FDE047',
  '#A78BFA',
  '#94A3B8',
];

const normalizeSeriesKey = (value: string) =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-ms$/, '');

const preferredColor = (
  lookup: Map<string, string>,
  key: string,
  name: string
) =>
  lookup.get(normalizeSeriesKey(key)) || lookup.get(normalizeSeriesKey(name));

export const assignSeriesColors = (
  series: { key: string; name: string }[],
  colors: Record<string, string>
): string[] => {
  const lookup = new Map<string, string>();

  Object.entries(colors).forEach(([key, color]) => {
    lookup.set(normalizeSeriesKey(key), color);
  });

  const used = new Set<string>();

  return series.map((item, index) => {
    const preferred = preferredColor(lookup, item.key, item.name);

    if (preferred && !used.has(preferred)) {
      used.add(preferred);
      return preferred;
    }

    const fallback =
      CHART_SERIES_PALETTE.find((color) => !used.has(color)) ||
      CHART_SERIES_PALETTE[index % CHART_SERIES_PALETTE.length];

    used.add(fallback);
    return fallback;
  });
};
